<h2 mat-dialog-title class="modal-header">
    Nouvel évènement
</h2>

<mat-dialog-content>

    @if((organisations$ | async); as organisations) {
    <form [formGroup]="eventFg" (ngSubmit)="submit()">
        <mat-form-field appearance="outline" class="w-100">
            <mat-label>Mes organisations</mat-label>
            <mat-select formControlName="organisationId" required>
                @for (org of organisations; track $index) {
                <mat-option [value]="org.id">{{org.name}} </mat-option>
                }
            </mat-select>
        </mat-form-field>

        <mat-form-field appearance="outline" class="w-100">
            <mat-label>Discipline</mat-label>
            <mat-select formControlName="typeSport" required>
                @for (sport of typeOfSport; track $index) {
                <mat-option [value]="sport.value">{{typeSportEnumText(sport.value)}} </mat-option>
                }
            </mat-select>
        </mat-form-field>

        <mat-form-field appearance="outline" class="w-100">
            <mat-label>Nom</mat-label>
            <input matInput type="text" formControlName="name">
        </mat-form-field>

        <mat-form-field appearance="outline" class="w-100">
            <mat-label>Code</mat-label>
            <input matInput type="text" formControlName="code">
        </mat-form-field>


        <mat-form-field appearance="outline" class="w-100">
            <mat-label>Date</mat-label>
            <input matInput type="date" formControlName="startDate">
        </mat-form-field>

        <div class="d-flex flex-row justify-content-center p2 gap-3">
            <button matButton="filled" color="primary" type="submit">Créer l'événement</button>
            <button matButton="outlined" color="primary" type="button" [mat-dialog-close]="false">Fermer</button>
        </div>
    </form>
    } @else {
    <p>Votre compte est lié à aucune organisation. Veuillez vous rapprocher de l'organisation à laquelle vous souhaitez
        travailler</p>
    <div class="d-flex flex-row justify-content-center">
        <button matButton="outlined" color="primary" type="button" [mat-dialog-close]="false">Fermer</button>
    </div>

    }


</mat-dialog-content>